<template>
  <b-nav vertical class="w-100 vertical-nav">
    <!-- dynamic menu -->
    <b-nav-item
      v-for="mi in menuItems"
      :key="mi.title"
      :active="mi.active"
      @click="
        mi.children
          ? (mi.childVisible = !mi.childVisible)
          : $router.push({ name: mi.routeName })
      "
    >
      <div v-if="hasPermissions(mi.permissions, mi.admin, mi.partner)">
        <div class="nav-menu-icon">
          <i :class="mi.icon" class="text-primary"></i>
        </div>

        <div class="nav-menu-text">{{ mi.title }}</div>

        <span v-if="mi.children">
          <div class="nav-menu-chevron">
            <i
              class="dd-ico lni lni-chevron-right"
              v-show="!mi.childVisible"
            ></i>
            <i class="dd-ico lni lni-chevron-up" v-show="mi.childVisible"></i>
          </div>

          <div style="clear: both"></div>

          <transition name="slide">
            <div class="menu-item-dropdown-con" v-if="mi.childVisible">
              <span v-for="mc in mi.children" :key="mc.title">
                <div
                  v-if="hasPermissions(mc.permissions)"
                  class="sub-menu-item"
                  @click="$router.push({ name: mc.routeName })"
                >
                  <div class="pl-3 border-bottom text-small">- {{ mc.title }}</div>
                </div>
              </span>
            </div>
          </transition>
        </span>
      </div>
      <div style="clear: both"></div>
    </b-nav-item>
  </b-nav>
</template>

<script>
import menuData from "@/data/menu";
import store from "@/store";

export default {
  data() {
    return {
      menuItems: menuData,
      permissions: [],
    };
  },

  mounted() {
    this.routeWatcher();
    this.permissions = this.$store.state.user.permissions.map(
      (x) => x.permission
    );
  },

  watch: {
    $route() {
      this.routeWatcher();
    },
  },

  methods: {
    routeWatcher() {
      this.menuItems.forEach((item) => {
        if (this.hasPath(item.paths)) {
          item.active = true;
        } else {
          item.active = false;
        }
      });

      //Close the menu by default if mobile when route changes
      if (window.screen.width < 992) {
        store.commit("menu/setMenuState", "close");
      }
    },

    hasPermissions: function (permList, admin, partner) {

      if(partner){
        return this.user.capacity=='Partner'
      }
      

      if (permList && permList.length > 0) {
        let matches = permList.filter((i) => this.permissions.includes(i));
        return matches.length > 0;
      }

      if (admin === true) {
        //admin only menu
        return this.user.is_admin == 1;
      } else {
        return true; //no permissions set show menu
      }
    },

    hasPath: function (pathsList) {
      let matches = pathsList.filter((i) => this.$route.path.includes(i));
      return matches.length > 0;
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  padding: 0;
  color: var(--text-black-50);
}
.nav-menu-text:hover {
  color: var(--primary);
}
.nav-link.active {
 // background-color: var(--app-background-color);
  color: var(--primary);
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
 // margin-left: 10px;
}
.nav-menu-icon {
  float: left;
  font-size: 21px;
  padding: 9px 25px;
}

.nav-menu-text {
  padding-top: 13px;
  float: left;
}

.nav-menu-chevron {
  padding-top: 0;
  padding-right: 11px;
  float: right;
}

.dropdown-item {
  color: #fff !important;
}

.menu-item-dropdown-con {
  //background-color: var(--app-background-color);
  padding: 7px 1px;
  border-bottom-left-radius: 24px;
  margin: 0 5px;

  .sub-menu-item {
    color: var(--text-body);
    font-size: var(--font-size);
    padding: 3px;
  }

  .sub-menu-item:hover {
    color: var(--primary);
  }
}

.dd-ico {
  float: right;
  font-size: 11px;
  margin-top: 20px;
}
</style>